import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { filter as arrayFilter } from 'lodash';

/**
 * Filter that takes array or streams + value to be ignored, and return input
 * with filtered out value
 */
@Pipe({ name: 'ignore' })
export class IgnorePipe implements PipeTransform {
  streamCache: WeakMap<any, any>;

  constructor() {
    'ngInject';

    this.streamCache = new WeakMap();
  }

  public transform(input: Observable<any> | any[], value: any): any {
    if (angular.isArray(input)) {
      return arrayFilter(input, (element) => element !== value);
    }

    if (angular.isObject(input) && angular.isFunction(input.subscribe)) {
      let cachedResults;

      if (this.streamCache.has(input)) {
        cachedResults = this.streamCache.get(input);

        if (!cachedResults[value]) {
          cachedResults[value] = input.pipe(
            filter((element) => element !== value),
          );
          this.streamCache.set(input, cachedResults);
        }
      } else {
        cachedResults = {
          [value]: input.pipe(filter((element) => element !== value)),
        };
        this.streamCache.set(input, cachedResults);
      }

      return cachedResults[value];
    }

    // consider adding string & object case
    return input;
  }
}
